import { postCoreDataSecurityAccessAuditExportSlice } from './post';

export const { requestPostCoreDataSecurityAccessAuditExport, resetPostCoreDataSecurityAccessAuditExport } =
	postCoreDataSecurityAccessAuditExportSlice.asyncActionCreators;
